import React from 'react';
import { Building } from 'lucide-react';

const DepartmentDropdown = ({ departments = [], value, onChange, disabled }) => {
  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
        <Building className="h-5 w-5 text-blue-600" />
      </div>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`pl-10 w-full rounded-lg border border-gray-300 bg-white py-2 text-gray-900 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 ${
          disabled ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
        required
      >
        <option value="">
          {disabled ? 'Select a degree first' : 'Select Department'}
        </option>
        {departments.map((dept) => (
          <option key={dept._id} value={dept.name}>
            {dept.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DepartmentDropdown;